var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"node-fs-info-table\">\n<h4>File System Info</h4>\n<table class=\"table table-condensed table-hover table-striped\">\n<tbody>\n<tr>\n<td>Available Space</td>\n<td>{{nFITableCtrl.fs.total.available_in_bytes | numeral: '0[.][0] b'}}</td>\n</tr>\n<tr>\n<td>Free Space</td>\n<td>{{nFITableCtrl.fs.total.free_in_bytes | numeral: '0[.][0] b'}}</td>\n</tr>\n<tr>\n<td>Total Space</td>\n<td>{{nFITableCtrl.fs.total.total_in_bytes | numeral: '0[.][0] b'}}</td>\n</tr>\n<tr ng-repeat=\"data in nFITableCtrl.datas\">\n<td>{{data.key}}</td>\n<td>{{data.value}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/node-fs-info-table/node-fs-info-table.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/node-fs-info-table/node-fs-info-table.template.html
// module id = 923
// module chunks = 0